import { render, staticRenderFns } from "./AthleteSelfAssessmentMetricDescription.vue?vue&type=template&id=0a524db8&scoped=true&"
import script from "./AthleteSelfAssessmentMetricDescription.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentMetricDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentMetricDescription.vue?vue&type=style&index=0&id=0a524db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a524db8",
  null
  
)

export default component.exports